<div class="container">
  <div class="login-container" v-if="!showMaintenanceScreen">
    <div class="row row-0" style="margin-left: 10px; margin-right: 10px;" v-if="displayLoginScreen">

      <div class="col-12 mt-3">
        <!-- cloudFrontURLからのアクセスの場合 -->
        <div v-if="isCloudfrontLoginPage">
          <div class="row">
            <!-- Components on the left side of pane -->
            <div class="col text-center">
              <div class="sub-title-style">{{ $t('message.header_signin_other_system') }}</div>
              <label v-html="labelLoginMessage().labelLoginTop" class="px-4 pb-2 pt-2 text-left label-sm"></label>
              <b-form-group v-for="(item, index) in samlAccountList" :key="index" class="form-group">
                <b-button variant="primary" v-on:click="redirectToIdpAdLogin(item)">
                  {{ item.name }}
                </b-button>
              </b-form-group>
            </div>
            <div class="center-line-style"></div>
          </div>
        </div>
        <!-- Other login pane (SOA,SCI,SOA_TP, SCI_TP) -->
        <div v-else>
          <div class="row">
            <!-- Components on the left side of pane -->
            <div class="col text-center">
              <label class="col-12 sub-title-style">{{ ssoDisplayLanguage }}</label>
              <label v-html="labelLoginMessage().labelLoginTop" class="px-4 pb-2 pt-2 text-left label-sm"></label>
              <b-form-group class="form-group">
                <b-button variant="primary" v-on:click="redirectToIdpAdLogin(errorAccountList)">
                  {{ errorAccountList.name }}
                </b-button>
              </b-form-group>
              <label v-html="labelLoginMessage().labelLoginBottom" class="px-4 text-left label-ext-sm"></label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-else>
    <maintenance-screen @forced-login="executeForcedLogin"></maintenance-screen>
  </div>
  <processing-view :processing="processing"></processing-view>
</div>